var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.getActorsOnTile(_vm.service.id)),function(actor){return _c('status',{key:actor.id,staticClass:"float-left mr-1",attrs:{"actor":actor,"on-tile":_vm.onTile}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }